import { render, staticRenderFns } from "./CardEvents.vue?vue&type=template&id=7f00eded&"
import script from "./CardEvents.vue?vue&type=script&lang=js&"
export * from "./CardEvents.vue?vue&type=script&lang=js&"
import style0 from "./CardEvents.vue?vue&type=style&index=0&id=7f00eded&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports